import {
  useDialogDismiss
} from "./4GZAUH66.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";

// src/popover/popover-dismiss.ts
var usePopoverDismiss = createHook((props) => {
  props = useDialogDismiss(props);
  return props;
});
var PopoverDismiss = createComponent(
  (props) => {
    const htmlProps = usePopoverDismiss(props);
    return createElement("button", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  PopoverDismiss.displayName = "PopoverDismiss";
}

export {
  usePopoverDismiss,
  PopoverDismiss
};
